import React, { useEffect, useState } from "react";
import { AxiosError } from 'axios';
import { ACCIDENT_SHEET_REPORT_TYPES, ACCIDENT_SHEET_STATUS, APP_MESSAGES, DATE_FORMATS } from "src/shared/config/src";
import { getCurrentChild } from "src/shared/redux-state/src";
import { fetchAccidentSheet, submitSignature } from 'src/shared/services/src/lib/accident';
import { uploadFileAsync } from "src/shared/services/src/lib/fileUpload";
import { ChildrenStoreData } from "src/shared/types/src";
import { AccidentSheetResponseType } from 'src/shared/types/src/lib/accidentSheet.types';
import { MediaAttachment } from 'src/shared/types/src/lib/app.types';
import { dateFormatter } from "src/shared/utils/src";
import { useAppDispatch, useAppSelector } from "../../services/store";
import { TimelineActions } from 'src/shared/redux-state/src/lib/timeline/TimelineSlice';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { CustomButton, WarningStatusTag, SuccessStatusTag, CustomImageView, CustomCheckbox, SignatureView} from 'src/app/components/commonComponents';
import ProfileLayout from "src/app/layouts/ProfileLayout";
import { toast } from "react-toastify";
import SignatureModal from "src/app/components/modals/SignatureModal";
import { AccidentSheetLoader } from "src/app/components";
import MediaCarouselModal from "src/app/components/modals/MediaCarouselModal";
import { navigateToDownloadAppScreen } from "src/app/utilities/helpers";
import TextRenderer from "src/app/components/commonComponents/TextRenderer";

const AccidentSheetDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams()

    const dispatch = useAppDispatch();

    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    // const [sheetID, setSheetId] = useState<number>();
    const [accidentSheet, setAccidentSheet] = useState<AccidentSheetResponseType>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [attachments, setAttachment] = useState<MediaAttachment[]>([]);
    // const [parentSign, setParentSign] = useState<string>('');
    // const [submitLoading, setSubmitLoading] = useState(false);
    // const [confirmed, setConfirmed] = useState<boolean>(false);
    // const [isSignatureModal, setIsSignatureModal] = useState<boolean>(false);
    const [showMediaCarouselModal, setShowMediaCarouselModal] = useState<boolean>(false);
    const [headerTitle, setHeaderTitle] = useState<string>('');

    useEffect(() => {
        (async () => {
            id && await init(Number(id));
        })();
    }, [id]);

    const formatHeader = (title: string) => {
        if (title === ACCIDENT_SHEET_REPORT_TYPES.ACCIDENT) return 'Accident Sheet';
        if (title === ACCIDENT_SHEET_REPORT_TYPES.PRE_EXISTING) return 'Pre-existing Accident Sheet';
        if (title === ACCIDENT_SHEET_REPORT_TYPES.INCIDENT) return 'Incident Sheet'
    };

    const renderHeaderTitle = (screenTitle: string) => {
        return (
            <p>{formatHeader(screenTitle)}</p>
        )
    };

    const init = async (accidentSheetID: number) => {
        try {
            setIsLoading(true);

            const response = await fetchAccidentSheet({
                child: currentChild,
                accidentSheetID
            });
            if (response && Object.keys(response).length > 0) {
                setHeaderTitle(location.state?.headerTitle ? location.state?.headerTitle : formatHeader(response?.accidentSheet?.reportType))
                setAccidentSheet(response?.accidentSheet);
                setAttachment([...response?.accidentSheet?.attachments, ...response?.accidentSheet?.bodyMaps])
            } else {
                toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
            }

        } catch (error) {
            if (error instanceof AxiosError) {
                const apiError = error as AxiosError;
                if (apiError && apiError.response) {
                    const { errors } = error.response?.data;
                    toast.error(errors.join(", "), { autoClose: 5000 });
                } else {
                    toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
                }
            }
        } finally {
            setIsLoading(false);
        }
    };

    const toggleMediaCarouselModal = () => {
        setShowMediaCarouselModal(!showMediaCarouselModal);
    }

    const renderAttachments = (item: any) => {
        return (
            <div className="pd-x-4 mg-t-8 accident-avatar-img-wrap">
                <CustomImageView
                    url={item?.media?.url}
                    onPressImage={toggleMediaCarouselModal}
                    resizeMode='contain'
                    customImageStyles="accident-avatar-img"
                />
            </div>
        )
    };

    // const addImage = (url: string) => {
    //     setParentSign(url)
    //     toggleSignatureModal()
    // };

    // const uploadSign = async () => {
    //     const fileObj: any = {
    //         name: JSON.stringify(Date.now()),
    //         uri: parentSign,
    //         type: 'image/png',
    //     }
    //     const formData = new FormData()
    //     formData.append("attachment", fileObj);

    //     const signRes = await uploadFileAsync({
    //         child: currentChild,
    //         formData: formData
    //     });

    //     if (signRes) {
    //         return signRes
    //     }

    //     return null
    // }

    // const submitSheet = async () => {
    //     try {
    //         if (!parentSign || !confirmed) {
    //             toast.error('Please add the signature and confirm to submit');
    //             return
    //         };

    //         setSubmitLoading(true);

    //         const signRes = await uploadSign();

    //         if (signRes && sheetID) {
    //             const response = await submitSignature({
    //                 child: currentChild,
    //                 accidentSheetID: sheetID,
    //                 fileName: signRes?.fileName
    //             });

    //             if (response && Object.keys(response).length && accidentSheet) {

    //                 const newSheet: AccidentSheetResponseType = {
    //                     ...accidentSheet,
    //                     status: response?.status,
    //                     parentSignature: {
    //                         ...accidentSheet.parentSignature,
    //                         signature: response?.signature
    //                     }
    //                 };

    //                 setAccidentSheet(newSheet)
    //                 setParentSign('');
    //                 setConfirmed(false);
    //                 dispatch(TimelineActions.updateAccidentSheetStatusInTimeline({ accidentSheetID: sheetID, status: response?.status }))
    //             }

    //         } else {
    //             toast.error('Could not submit accident. Try again!');
    //         }

    //     } catch (error) {
    //         console.log("Error Submitting", error)
    //         if (error instanceof AxiosError) {
    //             const apiError = error as AxiosError;
    //             if (apiError && apiError.response) {
    //                 const { errors } = error.response?.data;
    //                 toast.error(errors);
    //             } else {
    //                 toast.error(APP_MESSAGES.generalErrorMessage);
    //             }
    //         }
    //     } finally {
    //         setSubmitLoading(false);
    //     }
    // };

    // const toggleSignatureModal = () => {
    //     setIsSignatureModal(!isSignatureModal);
    // }

    return (
        <ProfileLayout title={headerTitle} fixedFooter={accidentSheet?.status === ACCIDENT_SHEET_STATUS.PENDING_PARENT_REVIEW ? true : false} isPrintPage={true} handlePrint={() => window.print()}>
            <>
            {/* {submitLoading ? <div>Full Screen Loader</div> : null} */}

            {isLoading ? <AccidentSheetLoader /> :
                    <>
                        {accidentSheet?.status && (
                            <div className="d-flex align-items-center justify-content-center mg-t-15">
                                {accidentSheet?.status === ACCIDENT_SHEET_STATUS.COMPLETED && (
                                    <SuccessStatusTag statusString={accidentSheet?.status} />
                                )}
                                {accidentSheet?.status !== ACCIDENT_SHEET_STATUS.COMPLETED && (
                                    <WarningStatusTag statusString={accidentSheet?.status} />
                                )}
                            </div>
                        )}

                        {accidentSheet?.timestamp ? <>
                            <div className="text-center fs-14 text-black mg-t-15">{dateFormatter(accidentSheet.timestamp, DATE_FORMATS.SHORT_DATE)} at {dateFormatter(accidentSheet?.timestamp, DATE_FORMATS.TIME_AMPM)}</div>
                        </> : null}
                        
                        <div className="d-flex flex-wrap mg-t-8 mx-n-4">
                            {attachments.length > 0 && attachments.map(item => {
                                return (
                                    renderAttachments(item)
                                )
                            })}
                        </div>

                        <div className="mx-n-20 pd-x-20 pd-b-15">
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-100 mb-1 fs-12'>Where it happened?</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.whereHappened?.value ?? ''}</div>
                            </div>
                            
                            {
                                accidentSheet?.whereHappened?.notes ? 
                                <div className='form-group mg-t-15'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>Notes</div>
                                    <div className='form-control read-only-control'><TextRenderer text={accidentSheet?.whereHappened?.notes ?? ''} /></div>
                                </div> : null
                            }
                        </div>

                        <div className="mx-n-20 pd-x-20 pd-b-15 border-top border-gray border-t-w-6">
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-100 mb-1 fs-12'>What happened?</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.whatHappened?.value ?? ''}</div>
                            </div>
                            {
                                accidentSheet?.whatHappened?.notes ? 
                                <div className='form-group mg-t-15'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>Notes</div>
                                    <div className='form-control read-only-control'><TextRenderer text={accidentSheet?.whatHappened?.notes ?? ''} /></div>
                                </div> : null
                            }
                        </div>

                        <div className="mx-n-20 pd-x-20 pd-b-15 border-top border-gray border-t-w-6">
                            <div className='form-group mg-t-15'>
                                <div className='form-label text-gray-100 mb-1 fs-12'>What injury occurred?</div>
                                <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.injury?.value ?? ''}</div>
                            </div>
                            {
                                accidentSheet?.injury.notes ?
                                <div className='form-group mg-t-15'>
                                    <div className='form-label text-gray-100 mb-1 fs-12'>Notes</div>
                                    <div className='form-control read-only-control'><TextRenderer text={accidentSheet?.injury.notes ?? ''} /></div>
                                </div> : null
                            }
                        </div>

                        <div className="mx-n-20 pd-x-20 pd-b-15 border-top border-gray border-t-w-6">
                            <div className='row gutter-15'>
                                <div className="col-6">
                                    <div className='form-group mg-t-15'>
                                        <div className='form-label text-gray-100 mb-1 fs-12'>Treatment given</div>
                                        <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.treatmentGiven ?? ''}</div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className='form-group mg-t-15'>
                                        <div className='form-label text-gray-100 mb-1 fs-12'>Medical aid sought</div>
                                        <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.medicalAidSought ?? ''}</div>
                                    </div>
                                </div>
                                {/* <div className="col-12">
                                    <div className='form-group mg-t-15'>
                                        <div className='form-label text-gray-100 mb-1 fs-12'>Any further actions taken (Risk Assessments / Removal of 
                                            equipment / Ofsted information)</div>
                                        <div className='form-control read-only-control d-flex align-items-center'>No</div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className={`mx-n-20 pd-x-20 ${accidentSheet?.status === ACCIDENT_SHEET_STATUS.COMPLETED ? 'pd-b-15 border-top border-gray border-t-w-6' : '' }`}>
                            {
                                (accidentSheet?.reportCompletedBy?.name || accidentSheet?.reportCompletedBy?.signature?.url) ?
                                    <>
                                        {
                                            (accidentSheet?.reportCompletedBy?.name) ?
                                                <div className='form-group mg-t-15'>
                                                    <div className='form-label text-gray-100 mb-1 fs-12'>Name of person completing report / job title</div>
                                                    <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.reportCompletedBy?.name ?? ''}</div>
                                                </div> : null
                                        }


                                        {accidentSheet?.reportCompletedBy?.signature?.url && (
                                            <div className='form-group mg-t-15'>
                                                <div className='form-label text-gray-100 mb-1 fs-12'>Signature of person completing report</div>
                                                <SignatureView url={accidentSheet?.reportCompletedBy?.signature?.url} />
                                            </div>
                                        )}
                                    </>: null
                            }
                            {
                                (accidentSheet?.witnessDetails?.name || accidentSheet?.witnessDetails?.signature?.url) ?
                                <>
                                    {
                                        (accidentSheet?.witnessDetails?.name) ?
                                            <div className='form-group mg-t-15'>
                                                <div className='form-label text-gray-100 mb-1 fs-12'>Name of witness</div>
                                                <p>{accidentSheet?.witnessDetails?.name ?? ''}</p>
                                            </div> : null
                                    }

                                    {accidentSheet?.witnessDetails?.signature?.url && (
                                        <div className='form-group mg-t-15'>
                                            <div className='form-label text-gray-100 mb-1 fs-12'>Signature of witnesses</div>
                                            <SignatureView url={accidentSheet?.witnessDetails?.signature?.url} />
                                        </div>
                                    )}
                                </>: null
                            }
                            {
                                (accidentSheet?.riddorDetails?.reported) ?
                                <>
                                    <div className='form-group mg-t-15'>
                                        <div className='form-label text-gray-100 mb-1 fs-12'>RIDDOR reportable accident</div>
                                        <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.riddorDetails?.reported ? 'Yes' : 'No'}</div>
                                    </div>
                                    <div className='row gutter-15'>
                                        <div className="col-6">
                                            <div className='form-group mg-t-15'>
                                                <div className='form-label text-gray-100 mb-1 fs-12'>RIDDOR number</div>
                                                <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.riddorDetails?.number ?? ''}</div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className='form-group mg-t-15'>
                                                <div className='form-label text-gray-100 mb-1 fs-12'>RIDDOR Date</div>
                                                <div className='form-control read-only-control d-flex align-items-center'>{dateFormatter(accidentSheet?.riddorDetails?.timestamp, DATE_FORMATS.SHORT_DATE) ?? ''}</div>
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                            {
                                accidentSheet?.parentContacted?.contacted ? 
                                <>
                                    <div className='form-group mg-t-15'>
                                        <div className='form-label text-gray-100 mb-1 fs-12'>Parent Contacted</div>
                                        <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.parentContacted?.contacted ? `Yes - ${dateFormatter(accidentSheet?.parentContacted?.timestamp, DATE_FORMATS.SHORT_DATE)} at ${dateFormatter(accidentSheet?.parentContacted?.timestamp, DATE_FORMATS.TIME_AMPM)}` : 'No'}</div>
                                    </div>

                                    {
                                        accidentSheet?.parentContacted?.notes ? 
                                        <div className='form-group mg-t-15'>
                                            <div className='form-label text-gray-100 mb-1 fs-12'>Notes</div>
                                            <div className='form-control read-only-control'><TextRenderer text={ accidentSheet?.parentContacted?.notes } /></div>
                                        </div> : null
                                    }
                                </> : null
                            }
                        </div>

                        {
                            (accidentSheet?.status === ACCIDENT_SHEET_STATUS.COMPLETED) && (
                                <div className="mx-n-20 pd-x-20 pd-b-15 border-top border-gray border-t-w-6">
                                    {
                                        accidentSheet?.parentSignature?.name && (
                                            <div className='form-group mg-t-15'>
                                                <div className='form-label text-gray-100 mb-1 fs-12'>Parent/Carer Name</div>
                                                <div className='form-control read-only-control d-flex align-items-center'>{accidentSheet?.parentSignature?.name ?? ''}</div>
                                            </div>
                                        )
                                    }
                                    {
                                        accidentSheet?.parentSignature?.timestamp && (
                                            <div className='form-group mg-t-15'>
                                                <div className='form-label text-gray-100 mb-1 fs-12'>Date</div>
                                                <div className='form-control read-only-control d-flex align-items-center'>{`${dateFormatter(accidentSheet?.parentSignature?.timestamp, DATE_FORMATS.SHORT_DATE)}`}</div>
                                            </div>
                                        )
                                    }
                                    {accidentSheet?.parentSignature?.signature?.url && (
                                        <div className='form-group mg-t-15'>
                                            <div className='form-label text-gray-100 mb-1 fs-12'>Parent signature</div>
                                            <SignatureView url={accidentSheet?.parentSignature?.signature?.url} />
                                        </div>
                                    )}
                                </div>
                            )
                        }

                        {accidentSheet?.status === ACCIDENT_SHEET_STATUS.PENDING_PARENT_REVIEW && (
                            <>
                                    {/* <p>Parent signature</p>
                                    <SignatureView onPress={toggleSignatureModal} url={parentSign} clickable={true} /> */}

                                    {/* <div>
                                        <p>Parent Acknowledgement</p>
                                        <div>
                                            <div>
                                                <CustomCheckbox
                                                    isChecked={confirmed}
                                                    onChange={(e) => setConfirmed(val => !val)}
                                                    label="I confirm I have read the report."
                                                />
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="section-fixed pd-b-10 pd-t-10 pd-x-20 print-element-hide"><CustomButton
                                        text="Submit"
                                        color="primary"
                                        // disabled={submitLoading}
                                        // onClick={submitSheet}
                                        onClick={navigateToDownloadAppScreen}
                                    />
                                    </div>
                                </>
                        )}
                    </>
            }
            </>
            {/* {isSignatureModal && <SignatureModal
                isModal={isSignatureModal}
                toggleModal={toggleSignatureModal}
                type={SIGNATURE_TYPE.SIGN}
                onSaveCallback={addImage}
            />} */}
            <MediaCarouselModal
                showMediaCarouselModal={showMediaCarouselModal}
                toggleMediaCarouselModal={toggleMediaCarouselModal}
                media={attachments || []}
            />
        </ProfileLayout>
    )
}

export default AccidentSheetDetails;